
export const PraesentierenErlaubnisse = ["JEDER", "ORGANISATION", "ORGANISATOR"] as const;

type PraesentierenErlaubnis = typeof PraesentierenErlaubnisse[number];

export default PraesentierenErlaubnis;
